<template>
  <div class="landing h-screen w-full text-white bg-black flex flex-wrap items-center justify-center p-10 content-between">
    <h1 class="text-transparent fixed">Architect Serving Launceston and Devonport</h1>
    <div class="h-24 w-full">
    </div>
    <LogoStacked class="w-full" />
    <div class="h-24 w-full flex justify-center">
      <div class="w-40">
        <LoadingBar />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import LogoStacked from '@/components/logos/LogoStacked.vue'
import LoadingBar from '@/components/icons/LoadingBar.vue'

export default {
  name: 'landing',
  components: {
    LogoStacked,
    LoadingBar
  },
  metaInfo () {
    return {
      title: 'Architecture in Devonport & Launceston | Starbox Architecture',
      meta: [
        {
          name: 'description',
          content: 'Starbox Architecture is a team of Devonport-based architects that serve individuals around Launceston. Visit us online to get started!'
        },
        {
          name: 'keywords',
          content: 'starbox,architecture,starbox architecture,tasmania,tasmanian,tasmanian architecture,tasmania architecture'
        }
      ]
    }
  },
  methods: {
    goToHome () {
      this.$router.replace('/home')
    }
  },
  created () {
    setTimeout(() => this.goToHome(), 3000)
  }
}
</script>
